module.exports = __webpack_public_path__ + "components/affiliate-fillers/booking/static/filler@2-d6632ae8f1fd64add016a84f3ed8128a.jpg";